import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import MenuIcon from '@material-ui/icons/Menu';

// Material components
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CartIcon from '@material-ui/icons/ShoppingCart';
import Typography from '@material-ui/core/Typography';
import withTheme from '@material-ui/core/styles/withTheme';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
// Actions
import { updateLayout, toggleSidenav, toggleNotifications } from '../../../actions/layout.actions';
import { changeTheme, changeThemeDirection } from '../../../actions/theme.actions';
import ProfileHeader from '../../../components/ProfileUser/ProfileUser';
import CartModal from '../../../components/CartModal';

// Menu Items
import menuItemsFun from '../../../config';
import cookie from 'react-cookies';
import AuthApi from '../../../util/AuthApi';
import Api from '../../../util/Api';
import SharedService from '../../../services/SharedService';

function setTitle(items, currentPath) {
  for (let i = 0; i < items.length; i += 1) {
    if (items[i].href && items[i].href === currentPath) {
      return items[i].title;
    }

    if (items[i].children) {
      const result = setTitle(items[i].children, currentPath);
      if (result) {
        return result;
      }
    }
  }
  return null;
}
let $this;
class ContentToolbar extends React.Component {
  state = {
    layoutMenuEl: null,
    layoutMenuOpen: false,
    themeMenuEl: null,
    themeMenuOpen: false,
    menuItems: [],
    cartItems: [],
    showMiniCArt: false,
  };

  componentDidMount = async () => {
    const groupId = JSON.parse(await cookie.load('groupId'));
    const result = await menuItemsFun();
    this.setState({ menuItems: result, groupId });
    if (groupId === 4) {
      this.getCartData();
      SharedService.cartChanged.subscribe((value) => {
        if (value) this.getCartData();
      });
    }
    $this = this;
    global.document.addEventListener('click', this.handleClick, false)
  }

  handleClick(event) {
    // if (event.target && event.target.className && event.target.className.includes('drpdwnMenu')) return;
    // if (event.target && (!event.target.className || !event.target.className.includes('open-menu'))) $this.setState({ showDropdown: false });
    if (event.target.matches('.miniCartDrpdwn') || event.target.matches('svg') || event.target.matches('path')) return;
    if (!event.target.matches('.open-cart')) $this.setState({ showMiniCArt: false });
  }

  getCartData = async () => {
    const { data } = await AuthApi.getDataFromServer(`${Api.cartUrl}?type=all`);
    const cartItems = (data && data.data && data.data.items && data.data.items.length !== 0) ? data.data.items : [];
    this.setState({ cartItems });
  }

  handleOpenLayoutClick = (event) => {
    this.setState({ layoutMenuEl: event.currentTarget, layoutMenuOpen: true });
  };

  handleSelectLayoutClick = (event, layout) => {
    this.props.updateLayout(layout);
    this.setState({ layoutMenuEl: null, layoutMenuOpen: false });
  }

  handleCloseLayoutClick = () => {
    this.setState({ layoutMenuEl: null, layoutMenuOpen: false });
  };

  handleOpenThemeClick = (event) => {
    this.setState({ themeMenuEl: event.currentTarget, themeMenuOpen: true });
  };

  handleSelectThemeClick = (event, selectedTheme) => {
    this.props.changeTheme(selectedTheme.theme);
    this.setState({ themeMenuEl: null, themeMenuOpen: false });
  }

  handleCloseThemeClick = () => {
    this.setState({ themeMenuEl: null, themeMenuOpen: false });
  };

  handleDirectionChange = (event, checked) => {
    this.props.changeThemeDirection({
      direction: checked === true ? 'rtl' : 'ltr'
    });
    this.setState({ themeMenuEl: null, themeMenuOpen: false });
  }

  toggleMiniCart = () => {
    this.setState({ showMiniCArt: !this.state.showMiniCArt });
  }

  render() {
    const {
      width,
      layout,
      location,
      theme
    } = this.props;
    const { menuItems, groupId, showMiniCArt, cartItems } = this.state;

    const showBurgerMenu = isWidthDown('sm', width) || !layout.sidenavOpen;
    return (
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open sidenav"
          style={{ display: showBurgerMenu ? 'block' : 'none' }}
          onClick={this.props.toggleSidenav}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="title" color="inherit" noWrap>
          {setTitle(menuItems, location.pathname) || ''}
        </Typography>
        <span className="portal-flex" />
        {/* <IconButton
          color="inherit"
          aria-label="change theme"
          onClick={this.handleOpenThemeClick}
        >
          <InvertColorsIcon />
        </IconButton>         */}


        {/* <IconButton
          color="inherit"
          aria-label="change layout"
          onClick={this.handleOpenLayoutClick}
        >
          <AppsIcon />
        </IconButton> */}
        <ProfileHeader props={this.props} />
        {
          (groupId === 4) && (
            <IconButton
              color="inherit"
              // aria-label="open notifications"
              className="miniCartDrpdwn"
              onClick={this.toggleMiniCart}
            >
              <CartIcon
                className="miniCartDrpdwn"
              />
              <span className="portal-badge miniCartDrpdwn">{cartItems.length}</span>
              {
                console.log("cartItems.length", cartItems.length)
              }
            </IconButton>
          )
        }
        {
          showMiniCArt && (
            <CartModal items={cartItems} />
          )
        }
        {/* <IconButton
          color="inherit"
          aria-label="open notifications"
          onClick={this.props.toggleNotifications}
        >
          <NotificationsIcon />
        </IconButton> */}
      </Toolbar>
    );
  }
}

function mapStateToProps(state) {
  return {
    layout: {
      sidenavOpen: state.layout.sidenavOpen
    }
  };
}

ContentToolbar.propTypes = {
  width: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    sidenavOpen: PropTypes.bool
  }).isRequired,
  theme: PropTypes.shape({}).isRequired,
  toggleSidenav: PropTypes.func.isRequired,
  toggleNotifications: PropTypes.func.isRequired,
  updateLayout: PropTypes.func.isRequired,
  changeTheme: PropTypes.func.isRequired,
  changeThemeDirection: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired
};

export default compose(
  withRouter,
  withWidth(),
  withTheme(),
  connect(mapStateToProps, {
    toggleSidenav,
    toggleNotifications,
    updateLayout,
    changeTheme,
    changeThemeDirection
  })
)(ContentToolbar);



// WEBPACK FOOTER //
// ./src/layouts/components/content-toolbar/content-toolbar.component.js